import QueryEmployee from "graphql/queries/QueryEmployee";
import _ from "lodash";
import store from "services/redux/store";
import { setDataMulti } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import QueryEmployees from "graphql/queries/QueryEmployees";
import QueryEmployeesComplex from "graphql/queries/QueryEmployeesComplex";
import QueryEmployeeFiltered from "graphql/queries/QueryEmployeeFiltered";
import QueryEmployeeSearch from 'graphql/queries/QueryEmployeeSearch'
import { createPagination } from 'utils/helper-pagination'
import ObjectEmployee from 'utils/objects/employee'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import HelperDate, { dateFormat } from 'utils/helper-date'

export default class FetchEmployee {

	static fetch( employeeGuid, { callbackSuccess = null, callbackError = null, callbackStart = null, dispatchDataToStore = false, instant = false } = {}  ) {
		GraphqlGroupedBuilder.addQuery( 'employee', QueryEmployee, {
			variables: {
				guid: employeeGuid,
				scanned_in_at: HelperDate.date().format( dateFormat.DATE )+'_after'
			},
			resultPath: [ 'employee' ],
			instant,
			callbackStart,
			callbackError,
			callbackSuccess: ( result ) => {
				if( dispatchDataToStore ) {
					store.dispatch( setDataMulti( {
						[ dataConstants.EMPLOYEE ] : result
					}));
				}
				
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						employee: result
					});
				}
			},
		})
	}
	
	static fetchAll( { guid = null, teamGuid = null, callbackSuccess = null, callbackError = null, callbackStart = null, variables = {}, dataSet = 'simple' } = {}  ) {
		if( teamGuid !== null ) {
			variables[ 'team_guid' ] = teamGuid;
		}

		if( guid !== null ) {
			if( typeof guid === 'string' ) {
				guid = [ guid ];
			}
			
			variables[ 'guid' ] = guid;
		}

		let query = QueryEmployees;
		if( dataSet === 'complex' ) {
			query = QueryEmployeesComplex;
		}
		
		GraphqlGroupedBuilder.addQuery( 'employees', query, {
			resultPath: [ 'employees' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						employees: ObjectEmployee.filterInvisible( result )
					});
				}
			},
		})
	}
	
	static search( { _employee, searchValue, queryPage = 1, queryLimit = 100, callbackSuccess = null, callbackError = null, callbackStart = null  } = {} ){
		GraphqlGroupedBuilder.addQuery( 'search', QueryEmployeeSearch, {
			variables: {
				search: searchValue,
				...createPagination( queryLimit, queryPage )
			},
			resultPath: [ 'employees' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					// Add the key and value
					// Filter out the employee self
					callbackSuccess({
						employees: ObjectEmployee.filterInvisible( _.filter( result , o => {
							return _employee?.guid !== o?.guid;
						} ) )
					});
				}
			},
		})
	}

	static fetchFiltered( { name = null, company_guid = null, department_guid = null, team_guid = null, jobtitle_guid = null , callbackSuccess = null, callbackError = null, callbackStart = null }  = {} ) {
		let variables = {};
		
		if( name !== null ) {
			variables[ 'name' ] = name;
		}
		
		if( company_guid !== null ) {
			variables[ 'company_guid' ] = company_guid;
		}
		
		if( department_guid !== null ) {
			variables[ 'department_guid' ] = department_guid;
		}
		
		if( team_guid !== null ) {
			variables[ 'team_guid' ] = team_guid;
		}
		
		if( jobtitle_guid !== null ) {
			variables[ 'jobtitle_guid' ] = jobtitle_guid;
		}
		
		GraphqlGroupedBuilder.addQuery( 'employees_filtered', QueryEmployeeFiltered, {
			variables: variables,
			resultPath: [ 'employees_filtered' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						employees: result
					});
				}
			},
		})
	}
}
